import { Box, Divider, Grid, Skeleton, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import ButtonStartIcon from '../../../../../button/ButtonStartIcon';
import { useSelector } from 'react-redux';
import InputField from '../../../../../FormControl/input/InputField';
import useFetchData from '../../../../../../hooks/useFetchData';
import usePeriodicalReportSetting from '../../../../../../hooks/periodical-report/usePeriodicalReportSetting';

const General = ({}) => {
  const permission = useSelector((state) => state?.session?.permissions['periodical-report-setting'] || {});
  const { data: settingData, isLoading } = useFetchData('periodical-report/setting');
  const [form, setForm] = React.useState({});
  const [loading, toggleLoading] = React.useState(false);
  const [errors, setInputErrors] = React.useState({});

  const { updateSetting } = usePeriodicalReportSetting();

  const onSave = async (e) => {
    e.preventDefault();
    toggleLoading(true);
    try {
      let result = await updateSetting(form);
      if (result.error) {
        setInputErrors(result);
      }
    } finally {
      toggleLoading(false);
    }
  };

  useEffect(() => {
    if (!isLoading && settingData) {
      setForm(settingData || {});
    }
  }, [isLoading]);


  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between sticky top-0 z-10 h-8'>
        <Typography variant='subtitle1' className='uppercase'>
          Output file information
        </Typography>
        {!isLoading && permission['updated'] && (
          <ButtonStartIcon onClick={onSave} color='secondary' variant='contained' startIcon={['fas', 'save']} loading={loading}>
            Save
          </ButtonStartIcon>
        )}
      </Box>
      <Box className='px-4 pt-6 pb-4'>
        <Grid item  container spacing={2} alignItems={'center'}>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit' color='primary' className='font-bold' align='right' component='p'>
              Output file name 
            </Typography>
          </Grid>
          <Grid item md={10} sm={9}>
            {isLoading ? (
              <Skeleton />
            ) : permission['updated'] ? (
              <InputField
                id='periodical-report-setting-name-input'
                name='name'
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                error={errors.name}
                disabled={loading}
              />
            ) : (
              settingData.name
            )}
          </Grid>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit' color='primary' className='font-bold' align='right' component='p'>
              Output file version
            </Typography>
          </Grid>
          <Grid item md={10} sm={9}>
            {isLoading ? (
              <Skeleton />
            ) : permission['updated'] ? (
              <InputField
                id='periodical-report-setting-version-input'
                name='version'
                value={form.version}
                onChange={(e) => setForm({ ...form, version: e.target.value })}
                error={errors.version}
                disabled={loading}
              />
            ) : (
              settingData.name
            )}
          </Grid>
          <Grid item md={12}>
            <Divider />
          </Grid>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit' color='primary' className='font-bold' align='right' component='p'>
              School entity 
            </Typography>
          </Grid>
          <Grid item md={10} sm={9}>
            {isLoading ? (
              <Skeleton />
            ) : permission['updated'] ? (
              <InputField
                id='periodical-report-setting-school-entity-input'
                name='schoolEntity'
                value={form.schoolEntity}
                onChange={(e) => setForm({ ...form, schoolEntity: e.target.value })}
                error={errors.schoolEntity}
                disabled={loading}
              />
            ) : (
              settingData.name
            )}
          </Grid>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit' color='primary' className='font-bold' align='right' component='p'>
              School number 
            </Typography>
          </Grid>
          <Grid item md={10} sm={9}>
            {isLoading ? (
              <Skeleton />
            ) : permission['updated'] ? (
              <InputField
                id='periodical-report-setting-school-number-input'
                name='schoolNumber'
                value={form.schoolNumber}
                onChange={(e) => setForm({ ...form, schoolNumber: e.target.value })}
                error={errors.schoolNumber}
                disabled={loading}
              />
            ) : (
              settingData.name
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default General;
